const baseUrlMapping = {
  localhost: 'http://localhost:4334/mf-manifest.json',
  'simplify.developers.telus.digital':
    'https://assets.wcpreview.telus.com/1100769639/simplify-release-page/v1/mf2/mf-manifest.json',
  'simplify.staging.developers.telus.digital':
    'https://assets.wcstage.telus.com/1100769639/simplify-release-page/v1/mf2/mf-manifest.json',
  'simplify.telus.com':
    'https://assets.telus.com/1100769639/simplify-release-page/v1/mf2/mf-manifest.json',
};

export const releases = {
  remote: 'simplify_hub_release_page_mfe',
  name: 'release-page',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: baseUrlMapping,
};

export default releases;
